import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { routes } from "./routes";
import Login from "../../Pages/Login";
import Navbar from "./index";

const MainRouter = (props) => {
  const [isAuth, setAuth] = useState(false);
  //Routes redirect without login (Sadanand Gadwal)
  const loginNotRequiedPaths = [
    "/courtCase/:reportDate",
    "/nextHearing/:reportDate",
    "/liaison-reports/:reportDate",
    "/liaison_own_report/:reportDate",
    "/liaison_all_report/:reportDate",
    "/liaison_shc_report/:reportDate",
    "/liaison_kns_report/:reportDate",
    "/task-wise-quantity/:reportDate",
    "/task-wise-date/:reportDate",
    "/project-date-change/:reportDate",
    "/overal-machinenary-planning/:reportDate",
    "/kethos-machinenary-planning/:reportDate",
    "resource-type-planning",
    "/birthdayWish",
    "/workAnniversary",
    "/enquiry-profile/form/:flag/:EnquiryID/:LoginuserId",
    "/enquiry-profile/form/:flag/:EnquiryID/:LoginuserId/thankyou",
    "/enquiry-profile/Feedback/:EnquiryID/:LoginuserId",
    "/enquiry-profile/Feedback/:EnquiryID/:LoginuserId/thankyou",
    "/EPA-Add/form/:EpaID/:LoginuserId",
    "/EPA-Add/form/:EpaID/:LoginuserId/thankyou",
    "/EPA-Add/detail/:EpaID/:LoginuserId",
    "/EPA-Add/preview/:EpaID/:LoginuserId",
    "/todo-pending/:LoginuserId",
    "/todo-pending-detail/:LoginuserId/:id",
    "/bd-pending-task/:LoginuserId",
    "/bd-pending-task-detail/:LoginuserId/:id",
    "/Liaison-process-share/:LoginuserId",
    "/Liaison-process-share-detail/:LoginuserId/:id",
    "/live-booking/form/:uniqueSiteID"
  ];

  useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user && user["user_id"]) {
        setAuth(true);
      }
    } catch (err) {
      setAuth(false);
    }
  });

  return (
    <div className="app-container bg-light">
      <div className="container pt-4 pb-4">
        <Routes>
          {routes.map(({ path, Component, exact, state = {}, isNavbar }) => {
            return (
              <Route
                path={path}
                exact={exact}
                key={path}
                element={
                  isAuth ? (
                    <React.Suspense fallback={<div>Loading...</div>}>
                      {isNavbar ? (
                        <Navbar>
                          <Component {...props} />
                        </Navbar>
                      ) : (
                        <Component {...props} />
                      )}
                    </React.Suspense>
                  ) : loginNotRequiedPaths.includes(path) ? (
                    <React.Suspense fallback={<div>Loading...</div>}>
                      <Component {...props} />
                    </React.Suspense>
                  ) : (
                    <Login />
                  )
                }
              />
            );
          })}
        </Routes>
      </div>
    </div>
  );
};

export default MainRouter;
